import styles from "./Modal.module.scss";

export const Modal = ({ isModalOpen, open, close, toggle, children }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      close?.();
    }
  };
  if (!isModalOpen) return null;
  return (
    <div className={styles.sidebarOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalWrapper}>{children}</div>
    </div>
  );
};
